import { logDebug } from "utility/Function";
import type { MessageOption, OptionsSource } from "./types";

const MAX_MESSAGE_OPTIONS = 4;

const isNonEmptyString = (value: unknown): value is string =>
  typeof value === "string" && value.length > 0;

function parseMessageOptions(raw: unknown): MessageOption[] | undefined {
  if (raw === undefined || raw === null) return undefined;
  if (!Array.isArray(raw)) {
    logDebug("Ori message options dropped: not an array");
    return undefined;
  }

  const valid: MessageOption[] = [];
  for (const item of raw) {
    const candidate = (item ?? {}) as { label?: unknown; value?: unknown };
    if (
      isNonEmptyString(candidate.label) &&
      isNonEmptyString(candidate.value)
    ) {
      valid.push({ label: candidate.label, value: candidate.value });
    }
  }

  const capped = valid.slice(0, MAX_MESSAGE_OPTIONS);
  if (capped.length < raw.length) {
    logDebug(`Ori message options: kept ${capped.length} of ${raw.length}`);
  }
  return capped.length > 0 ? capped : undefined;
}

export function parseOptions(raw: {
  options?: unknown;
  options_source?: unknown;
}): {
  options: MessageOption[] | undefined;
  options_source: OptionsSource | null;
} {
  const options = parseMessageOptions(raw.options);
  const source = raw.options_source;
  return {
    options,
    options_source:
      options && (source === "fallback" || source === "personal")
        ? source
        : null,
  };
}
